export const TRON_FEE_LIMIT = 30_000_000;
export const ZERO_TRX_IN_SUN_UNITS = 0;
